import { render, staticRenderFns } from "./create-board.vue?vue&type=template&id=36de0aad&"
import script from "./create-board.vue?vue&type=script&lang=js&"
export * from "./create-board.vue?vue&type=script&lang=js&"
import style0 from "./create-board.vue?vue&type=style&index=0&id=36de0aad&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports